/* eslint-disable react-hooks/exhaustive-deps */
import { FC, useEffect, useRef, useState } from "react";
import { useHistory } from "react-router-dom";
import { ROUTES } from "../../../utils/routes";
import Axios from "axios";
import { getAll } from "../../../utils/requests/dynamicReq";
import { paths } from "../../../utils/paths";

//search feature
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSearch } from "@fortawesome/free-solid-svg-icons";
import Col from "react-bootstrap/esm/Col";
import Form from "react-bootstrap/esm/Form";
import InputGroup from "react-bootstrap/esm/InputGroup";
import { searchInvestigators } from "../../../utils/auxiliar/investigators";
import { IInvestShort } from "../../../interfaces/IInvestigatorShort";
import { IInvestInvShort } from "../../../interfaces/IInvestigadorInvitadoShort";


export const InvestigadoresInvitados: FC = () => {
  const history = useHistory();

  const [isLoading, setIsLoading] = useState(false);

  const isMountedRef = useRef(false);
  const source = Axios.CancelToken.source();
  const { INVESTIGADORES_INVITADOS } = paths;
  const [investigators, setInvestigators] = useState<any>([]);
  const [search, setSearch] = useState("");
  const [filteredInvestigators, setFilteredInvestigators] = useState<
    IInvestInvShort[]
  >([]);

  useEffect(() => {
    setIsLoading(true);
    isMountedRef.current = true;
    loadInvestigators();
    return () => {
      isMountedRef.current = false;
      source.cancel();
    };
  }, []);

  const loadInvestigators = async () => {
    try {
      const response = await getAll(INVESTIGADORES_INVITADOS, source);
      if (isMountedRef.current) {
        filterInvestigators(response);
      }
      setIsLoading(false);
    } catch (error) {
      console.log("HTTP call cancelled");
    }
  };

  const filterInvestigators = (rawInvestigators: any[]) => {
    let investigators: IInvestInvShort[] = rawInvestigators.map(
      ({ id, name }) => ({
        id,
        name,        
      })
    );
    sortBySurname1(investigators)
  };

  const sortBySurname1 = (users: IInvestInvShort[]) => {
    users.sort((a, b) => a.name.localeCompare(b.name));
    setInvestigators(users);
    setFilteredInvestigators(users);
  };
 const handleSearch = (searchValue: string) => {
   setSearch(searchValue);
   const filtered = investigators.filter((investigators: any) =>
     investigators.name.toLowerCase().includes(searchValue.toLowerCase())
   );
   setFilteredInvestigators(filtered);
 };


  return (
    <div className="container-fluid p-4">
      {/* {(userRoleId === 1 || userRoleId === 2) && ( */}
      <>
        {" "}
        <div className="row">
          <div className="col d-flex justify-content-between">
            <div>
              <h3>Usuarios</h3>
            </div>
            <div>
              <button
                className="baseBtn"
                onClick={() => history.push(`${ROUTES.InvestigadoresInvitados.create}`)}
              >
                + Añadir
              </button>
            </div>
          </div>
        </div>
        <div className="row mt-4">
          <Form.Group as={Col}>
            <InputGroup className="shadow">
              <InputGroup.Prepend>
                <InputGroup.Text className="inputGroup ">
                  <FontAwesomeIcon color="#0073B5" icon={faSearch} />
                </InputGroup.Text>
              </InputGroup.Prepend>
              <Form.Control
                type="text"
                placeholder="Buscar..."
                className="form-control"
                value={search}
                onChange={(e) => handleSearch(e.target.value)}
              />
            </InputGroup>
          </Form.Group>
        </div>
        <div className="row">
          <div className="col-12 ">
            <table className="table table-hover">
              <tbody>
                {filteredInvestigators?.map(({ id, name }: IInvestInvShort) => (
                  <tr
                    key={id}
                    className="pointer"
                    onClick={() => history.push(`${ROUTES.InvestigadoresInvitados.all}/${id}`)}
                  >
                    <td>{`${name}`}</td>
                  </tr>
                ))}
              </tbody>
            </table>
            {isLoading && (
              <div className="d-flex justify-content-center">
                <div className="spinner-border mt-5" role="status" />
              </div>
            )}

            {!filteredInvestigators.length && !isLoading && (
              <div className="d-flex justify-content-center mb-3">
                <h5>-No existen investigadores externos-</h5>
              </div>
            )}
          </div>
        </div>
      </>
      {/* )} */}
    </div>
  );
};
